/**
 * Post status enum for type-safe status assignments.
 * Used primarily in admin forms and state management.
 */
export enum PostStatus {
  Published = 'published',
  Scheduled = 'scheduled',
  Private = 'private',
  Draft = 'draft',
  Pitch = 'pitch',
  Pending = 'pending',
}

/**
 * Type guard to check if a string is a valid PostStatus.
 * @param candidate - String to validate
 * @returns True if candidate is a valid PostStatus
 */
export const isPostStatus = (candidate: string): candidate is PostStatus => {
  return Object.values(PostStatus).some((value) => value === candidate);
};

/**
 * Post status as a union type for use in constants, API responses, and component props.
 * This type is preferred when receiving status values from external sources.
 */
export type PostStatusType =
  | 'published'
  | 'scheduled'
  | 'private'
  | 'draft'
  | 'pitch'
  | 'pending';

/**
 * Post type classification for different content categories.
 */
export type PostType =
  | 'Standard'
  | 'Featured'
  | 'Premiere'
  | 'Sponsored'
  | 'Submitted'
  | 'Promoted';
